import { FAQPageStructuredData } from "design-system/components/primitives/head/head";
import { documentToString } from "frontend/contentful/lib/document-to-string";
import { isContentType } from "frontend/contentful/lib/is-content-type";
import { AccordionEntry } from "frontend/contentful/schema/blocks";
import { PageSectionEntry } from "frontend/contentful/schema/semantics";
import { useContentful } from "frontend/hooks/use-contentful";

export function getFaqStructuredData(
  faqsEntry: PageSectionEntry | AccordionEntry,
): FAQPageStructuredData | undefined {
  const { getEntry, getEntries } = useContentful();

  const questions: FAQPageStructuredData["mainEntity"] = [];

  const pushAccordionItems = (accordion: AccordionEntry) => {
    const accordionBlock = getEntry(accordion);
    const items = accordionBlock?.fields.accordionItems;

    if (!items?.length) return;

    items.forEach((item) => {
      const itemEntry = getEntry(item);
      const fields = itemEntry?.fields;

      if (!fields) return;

      questions.push({
        "@type": "Question",
        name: documentToString(fields.title),
        acceptedAnswer: {
          "@type": "Answer",
          text: documentToString(fields.description),
        },
      });
    });
  };

  // Case 1: PageSection containing accordion blocks
  if (isContentType<PageSectionEntry>("pageSection", faqsEntry)) {
    const contentRefs = faqsEntry.fields.content;
    if (!contentRefs?.length) return undefined;

    const faqBlocks = getEntries(contentRefs);

    faqBlocks
      .filter((block) => isContentType<AccordionEntry>("accordion", block))
      .forEach((block) => pushAccordionItems(block));
  }

  // Case 2: Entry is itself an accordion
  if (isContentType<AccordionEntry>("accordion", faqsEntry)) {
    if (!faqsEntry.fields.accordionItems?.length) return undefined;
    pushAccordionItems(faqsEntry);
  }

  if (questions.length === 0) return undefined;

  return {
    "@type": "FAQPage",
    mainEntity: questions,
  };
}
